let base_url = "https://api.lemmofuture.com/mall" // 生产地址
// let base_url = "https://api.lemmo.cn/mall" // 测试地址

window.lemmoApi = window.lemmoApi || {};
window.lemmoApi = {
  base_url: '',
  config: {}
}
let os = function () {
  let ua = navigator.userAgent,
      isWindowsPhone = /(?:Windows Phone)/.test(ua),
      isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone,
      isAndroid = /(?:Android)/.test(ua),
      isFireFox = /(?:Firefox)/.test(ua),
      isChrome = /(?:Chrome|CriOS)/.test(ua),
      isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox &&
          /(?:Tablet)/.test(ua)),
      isPhone = /(?:iPhone)/.test(ua) && !isTablet,
      isPc = !isPhone && !isAndroid && !isSymbian;
    return isPc ? 'pc': isPhone ? 'iOS' : isAndroid ? 'android' : 'other'
}()
window.lemmoApi.base_url = base_url
let requestHeader = {

  'Content-Type': 'application/json',
  'lang': '', //    语言[zh-中文/en-英文/de-德语]
  'clientType': os,  //	客户端类型 1-pc/2-android/3-iOS/4-h5/5-other
  // 'Authorization': 'token', //  token
  // 'appVersion': 'appVersion', // 客户端app版本
  // 'channel': 'Channel', //    客户端渠道
  // 'deviceId': 'deviceId',    // 客户端设备号
  // 'machType': 'machType',    //   客户端机型
  // 'osVersion':  'osVersion', //   客户端系统
}
// /order/queryUrl 通过订单号和邮箱查询订单
let orderQueryUrl = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = '?email='+ pargram.email + '&orderNumber=' + pargram.orderNumber + '&shopifyMallId=1'
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/order/queryUrl' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/order/queryUrl' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
    
  })
}

// /order/queryOrderInfo 通过订单号和邮箱查询订单
let queryOrderInfo = (pargram) => {
  requestHeader.lang = pargram.lang
  const orderNumber = pargram.orderNumber;
  const encodedOrderNumber = encodeURIComponent(orderNumber);
  let requestBody = '?email='+ pargram.email + '&orderNumber=' + encodedOrderNumber + '&shopifyMallId=1'
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/order/queryOrderInfo' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })    
  })
}

// /shop/queryAll 查询所有门店
let shopqueryAll = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = `?shopFunction=${pargram.shopFunction || ''}`
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/shop/queryAll' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        console.log(response)
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/shop/queryAll' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
  })
}
// /shopTestRide/queryShopTestRide 查询门店试骑信息（车型与试骑时间）
let queryShopTestRide = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = '?shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/shopTestRide/queryShopTestRide' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/shopTestRide/queryShopTestRide' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
  })
}
// /shopTestRide/queryShopTestRideDate 查询门店试骑日期
let queryShopTestRideDate = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = '?guests='+ pargram.guests + '&shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/shopTestRide/queryShopTestRideDate' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/shopTestRide/queryShopTestRideDate' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
  })
}
// /shopTestRide/queryShopTestRideTimeList  查询门店某天试骑时间段列表
let queryShopTestRideTimeList = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = '?date='+ pargram.date + '&shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/shopTestRide/queryShopTestRideTimeList' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/shopTestRide/queryShopTestRideTimeList' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
  })
}
// /shopTestRide/apply 申请试骑
let shopTestRideApply = (pargram) => {
  requestHeader.lang = pargram.lang
  // let requestBody = '?date='+ pargram.date + '&shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    // $.ajax({
    //   type: 'POST',
    //   url: base_url + '/shopTestRide/apply',
    //   headers: requestHeader,
    //   dataType: 'json',
    //   body: JSON.stringify(pargram),
    //   success: function(response) {
    //     resolve(response)
    //   },
    //   error: function(e) {
    //     resolve(e)
    //   } 
    // })
    fetch(base_url + '/shopTestRide/apply', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// /shopTestRide/queryApply  查询试骑申请
let shopTestRideQueryApply = (pargram) => {
  requestHeader.lang = pargram.lang
  let requestBody = '?shopApplyId='+ pargram.shopApplyId
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/shopTestRide/queryApply' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
    // fetch(base_url + '/shopTestRide/queryApply' + requestBody, {
    //   method: 'GET',
    //   headers: requestHeader,
    //   // body: JSON.stringify(pargram)
    // }).then(response=>{
    //   return response.json();
    // }).then(e=>{
    //   resolve(e)
    // })
  })
}
// /shopTestRide/cancel 取消试骑
let shopTestRideCancel = (pargram) => {
  requestHeader.lang = pargram.lang
  // let requestBody = '?date='+ pargram.date + '&shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    // $.ajax({
    //   type: 'POST',
    //   url: base_url + '/shopTestRide/cancel',
    //   headers: requestHeader,
    //   dataType: 'json',
    //   body: JSON.stringify(pargram),
    //   success: function(response) {
    //     resolve(response)
    //   },
    //   error: function(e) {
    //     resolve(e)
    //   } 
    // })
    fetch(base_url + '/shopTestRide/cancel', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// /common/save/channel 保存渠道
let saveChannel = (pargram) => {
  requestHeader.lang = pargram.lang
  // let requestBody = '?date='+ pargram.date + '&shopId='+ pargram.shopId
  return new Promise((resolve,reject)=>{
    // $.ajax({
    //   type: 'POST',
    //   url: base_url + '/shopTestRide/cancel',
    //   headers: requestHeader,
    //   dataType: 'json',
    //   body: JSON.stringify(pargram),
    //   success: function(response) {
    //     resolve(response)
    //   },
    //   error: function(e) {
    //     resolve(e)
    //   } 
    // })
    fetch(base_url + '/common/save/channel', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// /common/save/subscribe 保存订阅
let subscribe = (pargram) => {
  requestHeader.lang = pargram.lang
  return new Promise((resolve,reject)=>{
    fetch(base_url + '/common/save/subscribe', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
//  /leasing/apply 租用申请
let leasingApply = (pargram) => {
  requestHeader.lang = pargram.lang

  return new Promise((resolve,reject)=>{
    fetch(base_url + '/leasing/apply', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
//  查询商城评论概览
let queryByShopifyMallId = (pargram) => {
  requestHeader.lang = pargram.lang;
  let requestBody = '/'+ pargram.shopifyMallId;
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/front/shopifyMallReviewSummary/queryByShopifyMallId' + requestBody,
      headers: requestHeader,
      dataType: 'json',
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
  })
}

//  dealer 点击统计
let dealerClick = (pargram) => {
  let requestBody = `?shopId=${pargram.shopId}&visitSource=${pargram.visitSource}&shopFunction=${pargram.shopFunction}`;
  return new Promise((resolve,reject)=>{
    $.ajax({
      type: 'GET',
      url: base_url + '/front/dealerVisitRecord/collect' + requestBody,
      headers: requestHeader,
      success: function(response) {
        resolve(response)
      },
      error: function(e) {
        resolve(e)
      } 
    })
  })
}
// /front/cargoSubscription/submit cargo订阅邮箱
let cargoemail = (pargram) => {
  requestHeader.lang = pargram.lang
  return new Promise((resolve,reject)=>{
    fetch(base_url + '/front/cargoSubscription/submit', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// /front/cargoReview/submit cargo订阅邮箱评论
let cargoreview = (pargram) => {
  requestHeader.lang = pargram.lang
  return new Promise((resolve,reject)=>{
    fetch(base_url + '/front/cargoReview/submit', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// front/websiteClickEvent/collect 网站点击事件
// front/websiteClickEvent/collect 网站点击事件
let clickEvent = (pargram) => {
  const body = new Blob(
    [JSON.stringify(pargram)],
    { type: 'application/json' }
  );

  navigator.sendBeacon(
    base_url + '/front/websiteClickEvent/collect',
    body
  );
};

// front/ebikePk/submit 前端-EbikePK管理
let ebikePk = (pargram) => {
  requestHeader.lang = pargram.lang
  return new Promise((resolve,reject)=>{
    fetch(base_url + '/front/ebikePk/submit', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
// /front/partnerApply/collect 合作申请
let merchants = (pargram) => {
  requestHeader.lang = pargram.lang
  return new Promise((resolve,reject)=>{
    fetch(base_url + '/front/partnerApply/collect', {
      method: 'POST',
      headers: requestHeader,
      body: JSON.stringify(pargram)
    }).then(response=>{
      return response.json();
    }).then(e=>{
      resolve(e)
    })
  })
}
window.lemmoApi.config.queryOrderInfo = queryOrderInfo
window.lemmoApi.config.orderQueryUrl = orderQueryUrl
window.lemmoApi.config.shopqueryAll = shopqueryAll
window.lemmoApi.config.queryShopTestRide = queryShopTestRide
window.lemmoApi.config.queryShopTestRideDate = queryShopTestRideDate
window.lemmoApi.config.queryShopTestRideTimeList = queryShopTestRideTimeList
window.lemmoApi.config.shopTestRideApply = shopTestRideApply
window.lemmoApi.config.shopTestRideQueryApply = shopTestRideQueryApply
window.lemmoApi.config.shopTestRideCancel = shopTestRideCancel
window.lemmoApi.config.saveChannel = saveChannel
window.lemmoApi.config.subscribe = subscribe
window.lemmoApi.config.leasingApply = leasingApply
window.lemmoApi.config.queryByShopifyMallId = queryByShopifyMallId
window.lemmoApi.config.dealerClick = dealerClick
window.lemmoApi.config.cargoemail = cargoemail
window.lemmoApi.config.cargoreview = cargoreview
window.lemmoApi.config.clickEvent = clickEvent
window.lemmoApi.config.ebikePk = ebikePk
window.lemmoApi.config.merchants = merchants
